import { Action, applyMiddleware, createStore, compose as composeEnhancers } from "redux";
import thunk, { ThunkAction } from "redux-thunk";
import rootReducer from "../reducers";

const initialState = {};

const middlewares = [thunk];

//const devtools = (
//    process.env.APP_ENV !== 'production' &&
//    typeof window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function" &&
//    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
//        trace: true,
//        traceLimit: 25,
//    })
//)

//const composeEnhancers = devtools || compose;

//if (process.env.APP_ENV !== 'production') {
//    // eslint-disable-next-line global-require
//    middlewares.push(logger);
//}

const store = createStore(
    rootReducer,
    initialState as Record<string, unknown>,
    composeEnhancers(applyMiddleware(...middlewares))
);

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
